import React, { useState } from "react";
import "./DataEstateWidget.scss";
import { percentageCalculation } from "../../../components/common/utilities";
import { useSelector } from "react-redux";
import Tooltip from "@mui/material/Tooltip";

export default function DataEstateWidget({ data = {} }) {
  const totalCount = useSelector((state) => state.dataTagReducer.totalFiles);

  const { processedFileCount = 0, dailyProcessedStats } = data;

  const pctObj = percentageCalculation(
    [{ count: processedFileCount }],
    totalCount
  );
  const pct = pctObj[0]?.count || 0;

  const size = 180;
  const strokeBg = 10;
  const strokeProgress = 22;
  const radius = (size - strokeProgress) / 2;
  const circumference = 2 * Math.PI * radius;
  const visibleArc = circumference * 0.75;
  const progressArc = (pct / 100) * visibleArc;
  const remainingFiles = totalCount - processedFileCount;

  const [hovered, setHovered] = useState(null);

  const tooltipContent = (
    <div className="data-estate-tooltip">
      <div className="tooltip-title">
        Files Processed: <strong>{pct}%</strong>
      </div>
      <div className="tooltip-sub">
        Remaining Files: {remainingFiles} / {totalCount}
      </div>
    </div>
  );

  return (
    <div className="data-estate-widget">
      <h4 className="widget-title-data-estate">Data Estate Coverage</h4>

      <div className="gauge-and-chart-wrapper">
        <div className="circle-wrapper">
          <Tooltip
            arrow
            placement="top"
            title={tooltipContent}
            disableInteractive
          >
            <div className="circle-container">
              <svg
                viewBox={`0 0 ${size} ${size}`}
                className="progress-svg"
                style={{ transform: "rotate(136deg)" }}
              >
                {/* Background Arc */}
                <circle
                  className={`ring-bg ${
                    hovered === "unfilled" ? "highlight" : ""
                  }`}
                  cx={size / 2}
                  cy={size / 2}
                  r={radius}
                  strokeWidth={strokeBg}
                  fill="none"
                  strokeDasharray={`${visibleArc} ${
                    circumference - visibleArc
                  }`}
                  onMouseEnter={() => setHovered("unfilled")}
                  onMouseLeave={() => setHovered(null)}
                />

                {/* Progress Arc */}
                <circle
                  className={`ring-progress ${
                    hovered === "filled" ? "highlight" : ""
                  }`}
                  cx={size / 2}
                  cy={size / 2}
                  r={radius}
                  strokeWidth={strokeProgress}
                  fill="none"
                  strokeDasharray={`${progressArc} ${
                    circumference - progressArc
                  }`}
                  strokeLinecap="round"
                  onMouseEnter={() => setHovered("filled")}
                  onMouseLeave={() => setHovered(null)}
                />
              </svg>

              {/* Center Content */}
              <div className="center-hover-zone">
                <div className="center-image-wrapper">
                  <div className="center-image-bg">
                    <img
                      src="/DataTagIcons/DataEstateIcon.svg"
                      alt="Data Estate"
                      className="center-image"
                    />
                  </div>
                </div>

                <div className="gauge-percentage">
                  <div className="pct-value">{pct}%</div>
                </div>
              </div>

              {/* Custom Hover Popup (optional, you can keep or remove) */}
              {hovered && (
                <div
                  className={`hover-popup ${
                    hovered === "filled"
                      ? "popup-right"
                      : hovered === "unfilled"
                      ? "popup-left"
                      : ""
                  }`}
                >
                  {hovered === "filled" && (
                    <>
                      <div>
                        <strong>Processed Files:</strong>{" "}
                        {processedFileCount}
                      </div>
                      <div>
                        <strong>Total Files:</strong> {totalCount}
                      </div>
                    </>
                  )}

                  {hovered === "unfilled" && (
                    <>
                      <div>
                        <strong>Remaining Files:</strong> {remainingFiles}
                      </div>
                      <div>
                        <strong>Total Files:</strong> {totalCount}
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>
          </Tooltip>
        </div>

        {/*
        <div className="processing-line-chart-container">
          <ProcessingLineChart
            rawData={dailyProcessedStats}
            totalFiles={totalCount}
          />
        </div>
        */}
      </div>
    </div>
  );
}